<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy,faDownload,faCheckCircle, faCommentsDollar,faClose,faCloudDownload } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'
    import Time from "svelte-time";
    

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    export let params = {};
    let txn = ''
    let loading = true


    let dataMember
    let isMember = false
    let dataDeposit
    let spBlock = false

    let transactionidss = ""

    let dataSlipimg = ""
    let dataSlipNumber = ""
    let dataSlip

    async function getMember() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getmember", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            dataMember = json.payload
            isMember = true
		}
        loading = false
    }
    async function getDeposit() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getdepositbyid", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({txn:txn})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            getMember()
            transactionidss = txn
            dataDeposit = json.payload
            if(dataDeposit.dep.transaction_slip=='bank_transfer'){
                dataSlip = JSON.parse(dataDeposit.dep.slip_url)
            }
            //dataSlip = dataDeposit.dep.slip_url
            dataSlipimg = dataDeposit.dep.slip_url
            // dataSlipNumber = dataSlip.account_number
            if(dataDeposit.dep.status=='W'){
                setTimeout(() => {
                    getDeposit2()
                }, 10000);
            }
		}
        // loading = false
    }

    async function getDeposit2() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getdepositbyid", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({txn:txn})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            dataDeposit = json.payload
            if(dataDeposit.dep.status=='W'){
                setTimeout(() => {
                    getDeposit2()
                }, 10000);
            }
		}
        // loading = false
    }

    let promise
    $: {

        if (params && params.txn) {
            txn = params.txn
            promise = getDeposit()
            // getMember()
        } 
    }

    
    let textarea;
	async function copyNumber(){
		textarea.select();
		document.execCommand('copy');
	}
    // getMember()

</script>
<div class="default-home">
<div class="row mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    <div class="col-12 text-center mt-3" ><h4 class="header-n">ฝากเงิน</h4></div>
    <div class="col-12 pb-5" style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        
        {#if dataDeposit.dep.status == 'E'}
        <div class="card mt-3 bg-black">
            <div class="card-body text-center">
                <div class="row mb-3">
                    <div class="col-3 text-center" ></div>
                    
                    <div class="col-3 text-center" ></div>
                </div>
                <Fa icon={faClose} size="3x" class="text-white"/>
                <h5 class="text-danger">รายการหมดอายุ</h5>
            </div>
        </div>
        {/if}
        {#if dataDeposit.dep.status == 'S'}
        <div class="card mt-3 bg-black">
            <div class="card-body text-center">
                <div class="row mb-3">
                    <div class="col-3 text-center" ></div>
                    
                    <div class="col-3 text-center" ></div>
                </div>
                <Fa icon={faCheckCircle} size="3x" class="text-white"/>
                <h5 class="text-success">ชำระเงินสำเร็จ</h5>
            </div>
        </div>
        {/if}

        {#if dataDeposit.dep.status == 'W'}
        <div class="card mt-3 bg-black">
            {#if dataDeposit.dep.transaction_slip == 'qr_code' || dataDeposit.dep.transaction_slip == ''}
                <div class="card-body text-center">
                    <img src="{dataDeposit.dep.slip_url}" class="img-fluid mb-2" style="max-width: 90%;">
                    <a href="https://onecash.g-onepay.com/p2w/download.php?txn={transactionidss}" class="btn btn-primary"><Fa icon={faCloudDownload} size="1x" class=" " /> บันทึกคิวอาร์โค๊ด</a>
                </div>
            {:else}
                <div class="card-body text-center">
                    <img src="./build/images/bank/{dataSlip.company_bank.bank_code.toLowerCase()}.png" class="img-fluid" style="max-width: 30%;">
                    {#if dataSlip.company_bank.bank_code == 'KTB'}
                    <h6 class="mt-4 text-warning">ธนาคารกรุงไทย</h6>
                    {:else if dataSlip.company_bank.bank_code == 'SCB'}
                    <h6 class="mt-4 text-warning">ธนาคารไทยพาณิชย์</h6>
                    {/if}
                    <h6 class="text-white">{dataSlip.company_bank.account_name}</h6>
                    <h5 class="mb-2 text-white">{dataSlip.company_bank.account_number} 
                        
                        <Clipboard
                        text= {dataSlip.company_bank.account_number}
                        let:copy
                        on:copy={() => {
                            Swal.fire(`คัดลอกแล้ว`)
                        }}>
                        <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1x"  pulse class="text-info " /></span>
                        </Clipboard>
                    
                    </h5>
                    <h5 class="text-white">{dataSlip.amount} บาท</h5>
                    <p class="text-danger mb-0">เวลาหมดอายุ</p>
                    <h6 class="text-warning"><Time timestamp="{dataSlip.expired_at}" format="DD/MM/YYYY HH:mm:ss" /></h6>
                    <small class="text-info ">กดคัดลอกหมายเลขบัญขี แล้วโอนเงิน</small>
                    
                </div>
            {/if}
        </div>
        <div class="card mt-3 bg-black">
            <div class="card-body text-center">
                
                <div class="row">
                    
                    <div class="col-12  mt-3" >
                        <p class="text-white">***กรุณาใช้ธนาคารนี้ในการโอนเงิน เท่านั้น</p>
                        <div class="card bg-black" style="border:1px solid white;">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-3">
                                        <img src="./assets/icon/bank/{dataDeposit.bank.bankcode}.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                                    </div>
                                    <div class="col-8 text-start text-white">
                                        <h6>{dataDeposit.bank.member_acc}</h6>
                                        <h6>{dataMember.member.member_name}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/if}



        {/if}
        
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-deposits">
        <HeaderThemes/>
        
        <div class="col-12 pb-5" style="min-height: 500px;">
            {#if loading}
            <div class="text-center mt-2" style="">
                <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
            </div>
            {/if}
            {#if !loading}
            {#if dataDeposit.dep.status == 'E'}
            <div class="card mt-3 bg-black ">
                <div class="card-body text-center">
                    <div class="row mb-3">
                        <div class="col-3 text-center" ></div>
                        
                        <div class="col-3 text-center" ></div>
                    </div>
                    <Fa icon={faClose} size="3x" class="text-white"/>
                    <h5 class="text-danger">รายการหมดอายุ</h5>
                </div>
            </div>
            {/if}
            {#if dataDeposit.dep.status == 'S'}
            <div class="card mt-5 bg-black">
                <div class="card-body text-center">
                    <div class="row mb-3">
                        <div class="col-3 text-center" ></div>
                        <div class="col-6 text-center" >
                            <img src="./assets/icon/gpay_logo.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                        </div>
                        <div class="col-3 text-center" ></div>
                    </div>
                    <Fa icon={faCheckCircle} size="3x" class="text-white"/>
                    <h5 class="text-success">ชำระเงินสำเร็จ</h5>
                </div>
            </div>
            {/if}

            {#if dataDeposit.dep.status == 'W'}
            <div class="card mt-5 bg-black">
                {#if dataDeposit.dep.transaction_slip == 'qr_code' || dataDeposit.dep.transaction_slip == ''}
                <div class="card-body text-center">
                    <img src="{dataDeposit.dep.slip_url}" class="img-fluid mb-2" style="max-width: 90%;">
                    <a href="https://onecash.g-onepay.com/p2w/download.php?txn={transactionidss}" class="btn btn-primary"><Fa icon={faCloudDownload} size="1x" class=" " /> บันทึกคิวอาร์โค๊ด</a>
                </div>
                {:else}
                    <div class="card-body text-center">
                        <img src="./build/images/bank/{dataSlip.company_bank.bank_code.toLowerCase()}.png" class="img-fluid" style="max-width: 30%;">
                        {#if dataSlip.company_bank.bank_code == 'KTB'}
                        <h6 class="mt-4 text-warning">ธนาคารกรุงไทย</h6>
                        {:else if dataSlip.company_bank.bank_code == 'SCB'}
                        <h6 class="mt-4 text-warning">ธนาคารไทยพาณิชย์</h6>
                        {/if}
                        <h6 class="text-white">{dataSlip.company_bank.account_name}</h6>
                        <h5 class="mb-2 text-white">{dataSlip.company_bank.account_number} 
                            
                            <Clipboard
                            text= {dataSlip.company_bank.account_number}
                            let:copy
                            on:copy={() => {
                                Swal.fire(`คัดลอกแล้ว`)
                            }}>
                            <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1x"  pulse class="text-info " /></span>
                            </Clipboard>
                        
                        </h5>
                        <h5 class="text-white">{dataSlip.amount} บาท</h5>
                        <p class="text-danger mb-0">เวลาหมดอายุ</p>
                        <h6 class="text-warning"><Time timestamp="{dataSlip.expired_at}" format="DD/MM/YYYY HH:mm:ss" /></h6>
                        <small class="text-info ">กดคัดลอกหมายเลขบัญขี แล้วโอนเงิน</small>
                        
                    </div>
                {/if}
        </div>
        <div class="card mt-3 bg-black">
            <div class="card-body text-center">
                
                <div class="row">
                    
                    <div class="col-12  mt-3" >
                        <p class="text-white">***กรุณาใช้ธนาคารนี้ในการโอนเงิน เท่านั้น</p>
                        <div class="card bg-black" style="border:1px solid white;">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-3">
                                        <img src="./assets/icon/bank/{dataDeposit.bank.bankcode}.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                                    </div>
                                    <div class="col-8 text-start text-white">
                                        <h6>{dataDeposit.bank.member_acc}</h6>
                                        <h6>{dataMember.member.member_name}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            {/if}

            {/if}
        </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">

</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-copys{
        padding: 4px 2px;
        font-size: .90rem;
        margin-top: 8px;
        padding: 5px 10px 5px 10px;
        font-weight: 400;
        color: #262626;
        background: #f9d62e;
        border-radius: 15px;
        line-height: unset;
        position: relative;
        top: -4px;
        border: 0px;
    }
    .blog-dng{
        font-size: 0.7rem !important;
        background: red;
        padding: 10px;
        color: #eb5757;
        background: #370e0e;
        border: 1px solid #eb5757;
        border-radius: 5px;
        text-align: center;
    }
    .btn-gd{
        /* --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300; */
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .bg-black{
        background: #000000ad !important;
    }
</style>